<template>
  <div class="combo-list">
    <div class="tuolele-main-box">
      <el-tabs
        v-model="filterObj.type"
        class="tll-tab-pane"
        @tab-click="handleClick"
      >
        <el-tab-pane label="托乐乐" name="1" />
        <el-tab-pane label="天天陪读" name="2" />
      </el-tabs>
      <div class="filter-form">
        <div class="filter-top">
          <div class="form-row">
            <div class="form-input fn-clear">
              <span>套餐名称</span>
              <el-input
                v-model="filterObj.item_title"
                size="large"
                placeholder="请输入查询内容"
              />
            </div>
            <div class="form-input">
              <span>课时类型</span>
              <el-select v-model="filterObj.item_type" placeholder="请选择">
                <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="form-input">
              <span>套餐状态</span>
              <el-select v-model="filterObj.is_delete" placeholder="请选择">
                <el-option label="全部" value />
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="form_btn">
              <el-button type="primary" @click="searchData">查询</el-button>
              <el-button
                v-if="!team_id"
                type="primary"
                @click="addCombo"
              >新增套餐</el-button>
            </div>
          </div>
          <div class="form-row">
            <div class="form-input fn-clear">
              <span class="fn-left">适用年级</span>
              <div class="fn-left">
                <Checkbox
                  :list.sync="gradeList"
                  :select-list="selectGrade"
                  @updateCheck="updateGrade"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="filter-body">
          <el-button type="success">Excel模板下载</el-button>
          <el-button type="primary">导入套餐</el-button>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              <p class="el-tooltip__popper-text">
                1、鼠标移入显示操作提示
                <br />2、操作提示：
                <br />1）导入的Excel请使用Excel模板哦，否则会导入失败！
                <br />2）可以点击【查看店铺ID】，查询各店铺对应的店铺ID，便于模板上传操作
              </p>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
          <span class="main-font-color">查看店铺ID</span>
        </div> -->
      </div>
    </div>
    <div class="table-main">
      <div class="table-header fn-clear">
        <div class="fn-right table-header-right">
          <el-pagination
            :current-page.sync="filterObj.p"
            :page-sizes="[10, 20, 27,30, 50,54,60]"
            :page-size="filterObj.limit"
            layout="sizes, prev, slot, next"
            prev-text="上一页"
            next-text="下一页"
            :total="itemTotal"
            @size-change="handleSizeChange"
          >
            <div class="chax">
              {{ filterObj.p }}/{{
                itemTotal > 0 ? Math.ceil(itemTotal / filterObj.limit) : 1
              }}
            </div>
          </el-pagination>
        </div>
      </div>
      <div class="table-body tuolele-main-box">
        <div class="table-btn fn-clear">
          <el-button
            v-if="!team_id"
            class="fn-right"
            type="danger"
            @click="deleteCombo"
          >关闭套餐</el-button>
          <el-button
            v-else
            class="fn-right"
            type="primary"
            @click="confirmCombo"
          >确认</el-button>
        </div>
        <el-table
          :data="itemList"
          border
          stripe
          :header-cell-style="{
            background: '#4c84ff',
            color: '#fff',
            height: '60px',
            textAlign: 'center'
          }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          />
          <el-table-column
            prop="item_id"
            label="套餐ID"
            align="center"
          />
          <el-table-column prop="name" label="套餐名称" />
          <!-- <el-table-column
            prop="shop_name"
            label="店铺名称"
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="type_name"
            label="课时类型"
            align="center"
          />
          <el-table-column
            label="套餐原价"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.original_price / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="total_price"
            label="套餐实际销售价"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.total_price / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="item_price"
            label="常规日均课耗"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.item_price / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="holiday_price"
            label="假期日均课耗"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.holiday_price / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="item_refund_price"
            label="常规日均退费"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.item_refund_price / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="holiday_refund_price"
            label="假期日均退费"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.holiday_refund_price / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="is_delete" label="套餐状态" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.is_delete == 0 ? "已开启" : "已关闭" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="补充协议" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.is_supplementary_agreement == 1 ? "显示" : "隐藏" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="limited_number"
            label="购买上限"
            align="center"
          />
          <el-table-column
            prop="grade_name"
            label="适用年级"
            align="center"
          />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="comboDetails(scope.row)"
              >查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="filterObj.p"
            prev-text="上一页"
            next-text="下一页"
            :total="itemTotal"
            :page-size="filterObj.limit"
          >
            <div class="chax">
              {{ filterObj.p }}/{{
                itemTotal > 0 ? Math.ceil(itemTotal / filterObj.limit) : 1
              }}
            </div>
          </el-pagination>
          <div class="insert">
            <el-button type="primary">确定</el-button>
            <span class="pagination-count">
              符合查询结果:
              <i>{{ itemTotal }}条</i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="套餐详情"
      :visible.sync="detailsVisible"
      class="combo-details"
    >
      <div
        v-if="[3, 4].indexOf(parseInt(comboShow.item_type)) > -1"
        class="self-table"
      >
        <div class="table-name">套餐名称 {{ comboShow.name }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>套餐类型</td>
                <td>扣费方式</td>
                <td>套餐课时</td>
                <td>套餐实际销售价</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in comboShow.sku_set" :key="item.key">
                <td>{{ item.summary }}</td>
                <td>月扣</td>
                <td>{{ item.days }}天</td>
                <td>{{ comboShow.price / 100 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="[1, 2, 6, 7, 8, 9, 30, 40, 31, 41].indexOf(parseInt(comboShow.item_type)) > -1"
        class="self-table"
      >
        <div class="table-name">套餐名称 {{ comboShow.name }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>扣费方式</td>
                <td>套餐课时</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in comboShow.sku_set" :key="item.key">
                <td>{{ item.summary }}</td>
                <td>{{ item.days }}天</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="[10, 11, 12, 13].indexOf(parseInt(comboShow.item_type)) > -1"
        class="self-table"
      >
        <div class="table-name">套餐名称 {{ comboShow.name }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>扣费方式</td>
                <td>套餐课时</td>
                <td>套餐有效期</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in comboShow.sku_set" :key="item.key">
                <td>{{ item.summary }}</td>
                <td>{{ item.days }}天</td>
                <td>{{ comboShow.begin_time }}~{{ comboShow.end_time }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="comboShow.combine_list && comboShow.combine_list.length>0" class="self-table" style="margin-top:20px">
        <div class="table-content">
          <div class="table-name">小学生赠送课时</div>
          <table>
            <thead>
              <tr>
                <td>科目</td>
                <td>类型</td>
                <td>数量</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in comboShow.combine_list" :key="item.id">
                <td>{{ item.subject_name }}</td>
                <td>{{ item.course_type_name }}</td>
                <td>{{ item.num }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="comboShow.product_info && comboShow.product_info.length>0"
        class="self-table"
      >
        <div class="table-name">其他费用</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>费用</td>
                <td>金额</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in comboShow.product_info " :key="`${item.classify_type}${index}`">
                <td>{{ item.classify_type_name }}</td>
                <td>{{ item.value/100 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog title="复制套餐操作" :visible.sync="copyComboFormVisible">
      <div class="title">设置套餐所适用的校区</div>
      <el-checkbox-group v-model="selectShop">
        <el-checkbox v-for="item in shopList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary">确定</el-button>
      </div>
    </el-dialog> -->
    <!-- <el-dialog title="批量导入套餐信息" :visible.sync="importComboFormVisible">
      <div slot="footer" class="dialog-footer">
        <el-button type="primary">导入</el-button>
      </div>
    </el-dialog> -->
    <el-dialog title="提醒" :close-on-click-modal="false" :visible.sync="bShowDepositDialog" width="650px">
      <h3 style="color:#E6A23C;font-size: 20px;margin-bottom: 10px;">有定金已绑定需要删除的套餐，不能直接关闭，请更换套餐后再关闭套餐</h3>
      <div class="wq_flex" style="margin-bottom:10px;padding-bottom: 5px">
        <div class="wq_flex_sub" style="font-size: 18px;">原套餐</div>
        <div class="wq_flex_sub" style="font-size: 18px;">更换套餐</div>
        <div style="font-size: 18px;width:100px;text-align: center;">操作</div>
      </div>
      <div v-for="(item,index) in depositPaid" :key="item.team_id" class="wq_flex" style="margin-bottom:10px;padding-bottom: 5px; border-bottom: 1px solid #dddddd;">
        <div class="wq_flex_sub" style="font-size: 16px;">{{ depositPaid[index].item_title }}</div>
        <div class="wq_flex_sub" style="font-size: 16px;">{{ depositPaid[index].change_item_name }}</div>

        <div>
          <el-button type="text" style="height: auto!important;" @click="fnChangeDeposit(index)">更换</el-button>

        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitChangeDeposit()">关闭全部</el-button>
      </div>
    </el-dialog>
    <el-dialog append-to-body :close-on-click-modal="false" title="绑定套餐" top="20vh!important" :visible.sync="bindPackageVisable" class="distribution-dialog" width="90%">
      <select-package-list :key="`bindPackage${bindPackageKey}`" type="1" :selected="currentSelectPackage" @selectPackage="selectSinglePackage" />
    </el-dialog>
  </div>
</template>

<script>
import Checkbox from '@/components/toolbar/Checkbox.vue';
import commondata from '@/utils/commondata';
import SelectPackageList from './components/select-package-list.vue';
export default {
  name: 'ComboList',
  components: {
    Checkbox,
    SelectPackageList
  },
  data() {
    return {
      // copyComboFormVisible: false,
      // importComboFormVisible: false,
      // shopSearchFormVisible: false,
      detailsVisible: false,
      comboShow: {},
      filterObj: {
        // shop_id: "",
        type: '1',
        grade_id: '',
        is_delete: '0',
        item_type: '',
        item_title: '',
        p: 1,
        limit: 10,
        team_id: this.$route.query.team_id
      },
      shopList: [],
      selectShop: [],
      typeList: [],
      statusList: [
        { text: '已开启', value: '0' },
        { text: '已关闭', value: '1' }
      ],
      itemList: [],
      itemTotal: 0,
      deleteIds: [],
      gradeList: commondata.GRADE_LISTS.map(e => {
        return { value: e.id, text: e.name }
      }),
      selectGrade: [],
      team_id: '',
      depositPaid: [],
      bShowDepositDialog: false,
      bindPackageVisable: false,
      bindPackageKey: 0,
      currentSelectPackage: ''
    }
  },
  computed: {},
  watch: {
    'filterObj.p': {
      handler: function() {
        this.getItemList(this.filterObj)
      }
    },
    'filterObj.limit': {
      handler: function() {
        this.getItemList(this.filterObj)
      }
    }
  },
  mounted() {
    // this.getMyShopList();
    this.team_id = this.$route.query.team_id
    this.getItemList(this.filterObj)
    this.getOrderType()
  },
  methods: {
    // async getMyShopList() {
    //   let ret = await this.$http.getMyShopList();
    //   if (ret.code == 200) {
    //     this.shopList = ret.data;
    //   }
    // },
    async getItemList(filterObj) {
      const ret = await this.$http.getItemList(filterObj)
      if (ret.code == 200) {
        this.itemList = ret.data.list
        this.itemTotal = ret.data.count - 0
      }
    },
    async getOrderType() {
      const ret = await this.$http.getOrderType()
      if (ret.code == 200) {
        const types = ret.data
        for (const key in types) {
          if (types.hasOwnProperty(key)) {
            this.typeList.push({
              text: types[key],
              value: key
            })
          }
        }
      }
    },
    searchData() {
      this.getItemList(this.filterObj)
    },
    handleSizeChange(val) {
      this.filterObj.limit = val
    },
    handleSelectionChange(val) {
      this.deleteIds = val.map(e => {
        return e.item_id
      })
    },
    async deleteCombo() {
      if (this.deleteIds.length == 0) {
        return
      }
      this.$confirm('确定关闭选中套餐吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.checkItemClose({
          id: this.deleteIds.join(',')
        }).then(res => {
          if (res.code == 200) {
            this.depositPaid = res.data
            if (this.depositPaid.length == 0) {
              this.changeRemoveItem()
            } else {
              this.bShowDepositDialog = true
            }
          }
        })
        // this.changeRemoveItem()
      })
    },
    fnSubmitChangeDeposit() {
      const emptyValIndex = this.depositPaid.findIndex(e => !e.change_item_id)
      if (emptyValIndex > -1) {
        this.$message({
          type: 'error',
          message: '请先选择套餐'
        })
        return
      }
      this.changeRemoveItem()
    },
    async selectSinglePackage(row) {
      const findDeleteIndex = this.deleteIds.findIndex(e => e == row.item_id)
      if (findDeleteIndex > -1) {
        this.$message({
          type: 'error',
          message: '该套餐已经在删除列表中，请重新选择'
        })
        return
      }
      try {
        this.$confirm('确定更换该套餐吗，确认后将立即更换？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false
        }).then(async() => {
          const currentIndex = this.depositPaid.findIndex(e => e.item_id == this.currentSelectPackage)
          await this.$http.changeDepositItem({
            old_item_id: this.depositPaid[currentIndex].item_id,
            new_item_id: row.item_id
          })
          this.depositPaid[currentIndex].change_item_id = row.item_id
          this.depositPaid[currentIndex].change_item_name = row.name
          this.bindPackageVisable = false
        })
        //
      } catch (error) {
        this.$message({
          type: 'error',
          message: error.message
        })
        return
      }
    },
    fnChangeDeposit(index) {
      this.currentSelectPackage = this.depositPaid[index].item_id
      this.bindPackageKey++
      this.bindPackageVisable = true
    },
    async changeRemoveItem() {
      const ret = await this.$http.changeRemoveItem({
        id: this.deleteIds.join(','),
        is_delete: 1
      })
      if (ret.code == 200) {
        this.$message({
          type: 'success',
          message: '关闭成功'
        })
        if (this.bShowDepositDialog) {
          this.bShowDepositDialog = false
        }
        this.getItemList(this.filterObj)
      }
    },
    addCombo() {
      this.$router.push({
        path: 'addCombo',
        query: {
          type: this.filterObj.type
        }
      })
    },
    comboDetails(item) {
      this.comboShow = item
      this.detailsVisible = true
    },
    updateGrade(val) {
      this.selectGrade = val
      this.filterObj.grade_id = val.join(',')
    },
    handleClick(val) {
      this.filterObj.type = val.name
      this.getItemList(this.filterObj)
    },
    confirmCombo() {
      if (this.deleteIds.length == 0) {
        return
      }
      this.$http
        .assignItemTeam({
          team_id: this.team_id,
          item_id: this.deleteIds.join(',')
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '添加套餐成功'
          })
          this.$router.push({
            path: 'editGroup',
            query: { team_id: this.team_id }
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.combo-list {
  .tuolele-main-box {
    ::v-deep .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 20px !important;
    }
    ::v-deep .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 20px !important;
    }
    .filter-form {
      .form-input,
      .form_btn {
        display: inline-block;
        margin-right: 20px;
      }
      .filter-top {
        // padding-bottom: 40px;
        // border-bottom: 1px solid #f5f5f5;
      }
      .filter-body {
        padding-top: 40px;
        .el-icon-question {
          color: $color_blue;
          font-size: 18px;
          margin-left: 10px;
          cursor: pointer;
        }
        span {
          font-size: 14px;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
  }
  .table-header {
    margin-bottom: 20px;
  }
  .table-btn {
    margin-bottom: 30px;
    .el-button {
      width: 120px;
      height: 40px;
    }
  }
  ::v-deep .el-dialog {
    -webkit-backface-visibility: hidden;
    width: 620px;
    min-height: 305px;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .el-dialog__header {
      padding: 30px 35px 20px 20px;
      border-bottom: solid 1px #f5f5f5;
      .el-dialog__title {
        color: $color_blue;
        font-size: 22px;
      }
      .el-dialog__close {
        color: $color_blue;
        font-size: 20px;
      }
      .el-dialog__headerbtn {
        top: 31px;
        right: 35px;
      }
    }
    .el-dialog__body {
      padding: 30px 35px 0 30px;
      .title {
        font-size: 18px;
        color: $color_black;
        margin-bottom: 25px;
      }
      .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        .el-checkbox {
          color: $color_black;
          font-size: 16px;
          margin-bottom: 20px;
          width: 33%;
        }
      }
      .search-shop {
        margin-bottom: 30px;
        .el-input {
          margin-right: 20px;
        }
      }
    }
    .el-dialog__footer {
      text-align: left;
      padding-left: 30px;
      .search-shop-result {
        color: $color_black;
        font-size: 16px;
        .shop-name {
          margin-right: 60px;
        }
        p {
          font-size: 18px;
          margin-bottom: 10px;
        }
      }
    }
    .el-button {
      width: 90px;
      height: 40px;
    }
  }
}

.el-input {
  width: 180px;
}

.el-select {
  width: 180px;
}

.filter-form {
  .el-button {
    padding: 0 30px;
    height: 40px;
  }
}

.self-table {
  margin-top: 0;
  .table-name {
    height: 60px;
    background-color: $color_blue;
    opacity: 0.7;
    line-height: 60px;
    color: #fff;
    text-align: center;
    font-size: 14px;
  }
}

::v-deep .el-dialog__wrapper {
  &.combo-details {
    .el-dialog {
      width: 900px;
      .el-dialog__body {
        padding: 30px 35px 30px 30px;
      }
    }
  }
}
.wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
</style>
